import Vue from 'vue'
import NotiFlag from './NotiFlag.vue'

const defaults = {
  title: null,
  subTitle: '',
  type: 'warning',
  autoClose: false,
};

const MtNotiFlagConstructor = Vue.extend(NotiFlag)


let currentMessage
let messageQueue = []
let countQ = 0
let positionTop = 20
let positionTopGap = 20 + 120

const showNextMessage = () => {

  let instance = new MtNotiFlagConstructor({
    el: document.createElement('div')
  });
  instance.action = ''
  instance.close = function(){
    instance.visibleFlag = false
    MtNotiFlag.rePosition(instance.mtNotiId)
    if(instance.onClose) instance.onClose()
    if(instance.timeOut) clearTimeout(instance.timeOut)
  }

  if (!instance.visible) {
    if (messageQueue.length > 0) {

      currentMessage = messageQueue[messageQueue.length - 1]
      if(currentMessage.options.autoClose) instance.timeOut = setTimeout(function(){ instance.close() }, 3000);
      positionTop = 20 + (messageQueue.length - 1) * positionTopGap

      let options = currentMessage.options
      options.mtNotiPositionTop = positionTop
      options.mtNotiId = countQ
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visibleFlag = true
      });
      messageQueue[messageQueue.length - 1]['instance'] = instance
      countQ++
    }
  }

}


const MtNotiFlag = function(options) {
  messageQueue.push({
    options: Object.assign({}, defaults, options),
  });

  showNextMessage()
}

MtNotiFlag.rePosition = (targetId) => {
  let newMessageQue = messageQueue.filter((message) => {
    if(message.instance.mtNotiId !== targetId) return message
  })
  messageQueue = newMessageQue
  messageQueue.map((message, index) => {
    message.instance.mtNotiPositionTop = 20 + index * positionTopGap
    let ele = document.getElementById(`mt-noti-flag-${message.instance.mtNotiId}`)
    ele.style.top = 20 + index * positionTopGap + 'px'
  })
};

MtNotiFlag.flag = (title, subTitle, options) => {
  return MtNotiFlag( Object.assign({}, {
    title: title,
    subTitle: subTitle,
  }, options));
};

export default MtNotiFlag



// WEBPACK FOOTER //
// ./src/plugins/mtui/noti-flag/index.js